var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{directives:[{name:"can",rawName:"v-can:[togglePermission]",arg:_vm.togglePermission}],attrs:{"input-value":_vm.item.isActivated,"inset":"","readonly":""},on:{"click":function($event){return _vm.toggleActivation()}}})}
var staticRenderFns = []

export { render, staticRenderFns }